<template>
  <RfDialog ref="awsLambdaModal" title="AWS S3 Credentials" width="700" hideConfirm>
    <div class="flex flex-col gap-7">
      <RfSwitch
        v-model="showCredentials"
        title="Show Credentials"
        class="mr-auto ml-0 flex-row-reverse"
      />
      <RfInput
        disabled
        title="AWS Bucket ID"
        placeholder="AWS Bucket ID"
        variant="outlined"
        class="w-full"
        :modelValue="props.awsUserName"
      />
      <RfInput
        disabled
        title="Upload Location"
        placeholder="Upload Location"
        variant="outlined"
        class="w-full"
        :modelValue="props.awsPath"
      />
      <RfInput
        disabled
        :loading="props.loading"
        title="Access Key"
        placeholder="Access Key"
        variant="outlined"
        class="w-full"
        :modelValue="props.awsAccessKey"
      />
      <RfInput
        disabled
        :loading="props.loading"
        title="Secret Key"
        placeholder="Secret Key"
        variant="outlined"
        class="w-full"
        :modelValue="props.awsSecretKey"
      />
    </div>
  </RfDialog>
</template>

<script setup>
import RfInput from "@/components/inputs/RfInput.vue";
import RfSwitch from "@/components/inputs/RfSwitch.vue";
import RfDialog from "@/components/modals/RfDialog.vue";
import { computed, ref } from "vue";

const emit = defineEmits(["update:showCredentials"]);
const props = defineProps({
  awsUserName: { type: String, default: "" },
  awsPath: { type: String, default: "" },
  awsAccessKey: { type: String, default: "" },
  awsSecretKey: { type: String, default: "" },
  loading: { type: Boolean, default: false },
});

const awsLambdaModal = ref();
const showCredentialsValue = ref(false);

const showCredentials = computed({
  get: () => showCredentialsValue.value,
  set: v => {
    showCredentialsValue.value = v;
    emit("update:showCredentials", v);
  },
});

const show = () => awsLambdaModal.value?.open();
const close = () => awsLambdaModal.value?.close();

defineExpose({ show, close });
</script>
